export function useGeniusMonkey() {
  const { geniusMonkeyPixelUrl, geniusMonkeyPixelSignupId } = useRuntimeConfig().public;

  const fireTrackingPixel = (params: Record<string, any>) => {
    if (!geniusMonkeyPixelUrl) return;

    const finalParams = {
      ...params,
      _cache: `${Date.now()}`,
    };

    const queryString = new URLSearchParams(finalParams).toString();
    const pixelUrl = `${geniusMonkeyPixelUrl}?${queryString}`;

    const pixel = new Image(1, 1);
    pixel.src = pixelUrl;
  };

  const fireSignUpPixel = () => {
    fireTrackingPixel({ id: geniusMonkeyPixelSignupId });
  };

  return {
    fireTrackingPixel,
    fireSignUpPixel,
  };
}
